import { useCallback, useEffect, useState } from "react"

import { useSelector } from "react-redux"

import { selectKpi } from "../../redux/receipt.slice"
import { buildKpiCards } from "./kpiCards"
import { KpiCardsGrid } from "./KpiCardsGrid"

// §BLOCK 2 — 4 non-interactive cards, respond to program selector (see ./kpiCards.js).

export const KpiCards = ({ getReceiptKpi, isDemo, isActive }) => {
  const kpi = useSelector(selectKpi)
  const [loading, setLoading] = useState(false)

  const handleGetReceiptKpi = useCallback(async () => {
    try {
      setLoading(true)
      await getReceiptKpi()
    } finally {
      setLoading(false)
    }
  }, [getReceiptKpi])

  useEffect(() => {
    if (isActive || isDemo) void handleGetReceiptKpi()
  }, [handleGetReceiptKpi, isActive, isDemo])

  return <KpiCardsGrid cards={buildKpiCards(kpi)} loading={loading} />
}
